import { useAuth } from '../auth/useAuth.js';
import { useTenantContext } from '../api/tenant-context.js';
import { config } from '../config.js';
import { t } from '../i18n/es.js';

export function Topbar(): JSX.Element {
  const { tenant } = useTenantContext();
  const { logout } = useAuth();
  const tenantName = tenant?.name ?? '—';
  return (
    <header
      className="col-start-2 flex items-center gap-3.5 px-7 h-14"
      style={{ background: 'var(--bg)', borderBottom: '1px solid var(--border)' }}
    >
      <div
        className="flex items-center gap-2.5 px-3 py-1.5 rounded-[6px] text-[13px]"
        style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
      >
        <span className="dot dot-ok" />
        {tenantName} · {config.envLabel === 'prod' ? t.topbar.env : config.envLabel}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: 'var(--text-3)', marginLeft: 4 }}>
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </div>
      <div className="flex-1" />
      <button
        type="button"
        title={`${t.topbar.notifications} — próximamente`}
        aria-label={t.topbar.notifications}
        onClick={() => alert('Notificaciones — próximamente. Por ahora podés monitorear desde Estado de plataforma.')}
        className="relative w-8 h-8 flex items-center justify-center rounded-[6px] text-ink-3 hover:bg-surface hover:text-ink-1"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        <span
          className="absolute"
          style={{ top: 7, right: 8, width: 6, height: 6, background: 'var(--brand)', borderRadius: '50%' }}
        />
      </button>
      <button
        type="button"
        title={t.topbar.help}
        aria-label={t.topbar.help}
        onClick={() => window.open('https://docs.zerviz.com/zengine', '_blank', 'noopener,noreferrer')}
        className="w-8 h-8 flex items-center justify-center rounded-[6px] text-ink-3 hover:bg-surface hover:text-ink-1"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </button>
      <button
        type="button"
        onClick={logout}
        className="btn btn-secondary"
      >
        {t.app.logout}
      </button>
    </header>
  );
}
